import type { AxiosResponse } from 'axios'
import type { InternalErrorResponse } from '@/services/transport/types'
import { TmApiLockedError } from '@/core/error/transport/tmApiLockedError'
import type { TfaAdditionalData } from '@/services/auth/types'

export class TmApiNeedEmailTfaError extends TmApiLockedError {
  public name = 'TmApiNeedEmailTfaError'

  public get credentials(): TfaAdditionalData {
    return this.data?.data as TfaAdditionalData
  }

  constructor(_?: string, data?: AxiosResponse<InternalErrorResponse>, stack?: string) {
    super('Need to pass 2fa check (email)', data, stack)
  }
}
